// English + Khmer translation dictionaries for Car Market
export const translations = {
  en: {
    // Brand
    "brand.name": "Car Market",
    "brand.tagline": "Your dream car, our goal.",

    // Nav
    "nav.home": "Home",
    "nav.buy": "Buy",
    "nav.rent": "Rent",
    "nav.sell": "Sell",
    "nav.account": "Account",
    "nav.admin": "Admin",
    "nav.dashboard": "Dashboard",
    "nav.sign_in": "Sign in",
    "nav.sign_out": "Sign out",
    "nav.pricing": "Pricing",
    "nav.blog": "Blog",

    // Home hero
    "home.hero.badge": "Cambodia's mobile-first car marketplace",
    "home.hero.title_1": "Find your next Car",
    "home.hero.title_2": "here.",
    "home.hero.subtitle": "Buy, rent or sell — fast. Verified dealers, transparent pricing, and a flow that feels like a phone in your pocket.",
    "home.hero.search_placeholder": "Search by brand, model, location…",
    "home.hero.search_btn": "Search",
    "home.hero.tab.buy": "Buy",
    "home.hero.tab.rent": "Rent",
    "home.hero.tab.sell": "Sell",

    // Home quick actions
    "home.qa.buy": "Buy a Car",
    "home.qa.rent": "Rent a Car",
    "home.qa.sell": "Sell My Car",
    "home.qa.dealer": "Dealer Login",

    // Home sections
    "home.featured": "Featured Cars",
    "home.featured.sub": "Hand-picked premium listings",
    "home.brands": "Popular Brands",
    "home.latest": "Latest Listings",
    "home.latest.sub": "Fresh on the market",
    "home.rentals": "Rental Cars Near You",
    "home.rentals.sub": "From $65/day · Insurance included",
    "home.dealers": "Trusted Dealers",
    "home.dealers.sub": "Verified partners across Cambodia",
    "home.how": "How It Works",
    "home.how.browse.t": "Browse",
    "home.how.browse.d": "Discover thousands of cars for sale or rent across Cambodia.",
    "home.how.connect.t": "Connect",
    "home.how.connect.d": "Tap to call or Telegram the seller in seconds.",
    "home.how.confidence.t": "Confidence",
    "home.how.confidence.d": "Verified dealers, transparent specs, and admin-approved listings.",
    "home.view_all": "View all",

    // Buy/Rent
    "buy.title": "Cars for Sale",
    "buy.results": "results",
    "buy.empty": "No listings match your filters.",
    "buy.search.placeholder": "Search Toyota, Lexus, Honda…",
    "buy.filters": "Filters",
    "buy.clear": "Clear filters",
    "buy.sort.newest": "Newest",
    "buy.sort.price_asc": "Price: Low → High",
    "buy.sort.price_desc": "Price: High → Low",
    "buy.sort.most_viewed": "Most viewed",
    "rent.title": "Rental Cars",
    "rent.subtitle": "Daily, weekly and monthly options. Insurance available.",
    "rent.cars": "cars",
    "rent.empty": "No rentals match your filters.",
    "rent.search.placeholder": "Find a rental car…",

    // Filter labels
    "filter.brand": "Brand",
    "filter.body": "Body",
    "filter.fuel": "Fuel",
    "filter.transmission": "Transmission",
    "filter.condition": "Condition",
    "filter.location": "Location",
    "filter.price_min": "Min $",
    "filter.price_max": "Max $",
    "filter.year_min": "Year from",
    "filter.year_max": "Year to",
    "filter.any": "Any",

    // Sell
    "sell.title": "Sell or Rent your car",
    "sell.subtitle": "List in minutes. Admin approves before going live.",
    "sell.step.type": "Type",
    "sell.step.vehicle": "Vehicle",
    "sell.step.details": "Details",
    "sell.step.photos": "Photos",
    "sell.step.review": "Review",
    "sell.type.q": "What are you listing?",
    "sell.type.sale": "For Sale",
    "sell.type.sale_d": "List your car for sale",
    "sell.type.rental": "For Rent",
    "sell.type.rental_d": "Rent out your car",
    "sell.photos.title": "Add photos",
    "sell.photos.subtitle": "Up to 10 high-quality photos help your listing stand out.",
    "sell.photos.add": "Add photos",
    "sell.photos.uploading": "Uploading…",
    "sell.review.title": "Review your listing",
    "sell.review.disclaimer": "By submitting you agree the listing will be reviewed by Car Market admin before being published.",
    "sell.back": "Back",
    "sell.next": "Next",
    "sell.submit": "Submit listing",
    "sell.success": "Listing submitted! Pending admin approval.",

    // Listing detail
    "listing.specs": "Specifications",
    "listing.description": "Description",
    "listing.similar": "Similar cars",
    "listing.report": "Report this listing",
    "listing.call": "Call seller",
    "listing.whatsapp": "WhatsApp",
    "listing.telegram": "Telegram",
    "listing.enquire": "Send enquiry",
    "listing.req_rental": "Request rental",
    "listing.private_seller": "Private Seller",
    "listing.views": "views",
    "listing.featured": "Featured",
    "listing.for_rent": "For Rent",
    "listing.from_per_mo": "From",

    // Enquiry/Rental modals
    "enq.title": "Send enquiry",
    "enq.name": "Your name",
    "enq.phone": "Phone",
    "enq.email": "Email (optional)",
    "enq.message": "Message",
    "enq.submit": "Send enquiry",
    "enq.success": "Enquiry sent! The seller will be in touch.",
    "rent.modal.title": "Request rental",
    "rent.modal.pickup": "Pickup date",
    "rent.modal.return": "Return date",
    "rent.modal.pickup_loc": "Pickup location",
    "rent.modal.notes": "Notes",
    "rent.modal.submit": "Submit rental request",
    "rent.modal.success": "Rental request sent!",

    // Auth
    "auth.welcome_back": "Welcome back",
    "auth.signin_sub": "Sign in to your Car Market account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signin": "Sign in",
    "auth.no_account": "New here?",
    "auth.create_account": "Create an account",
    "auth.signup_title": "Create your account",
    "auth.signup_sub": "Start buying, renting or selling cars",
    "auth.role_buyer": "I'm a buyer",
    "auth.role_dealer": "I'm a dealer",
    "auth.full_name": "Full name",
    "auth.phone_optional": "Phone (optional)",
    "auth.signup": "Create account",
    "auth.have_account": "Already have an account?",
    "auth.welcome_toast": "Welcome back!",
    "auth.created_toast": "Account created!",

    // Account
    "account.tab.listings": "My Listings",
    "account.tab.saved": "Saved",
    "account.tab.enquiries": "Enquiries",
    "account.tab.profile": "Profile",
    "account.empty.listings": "You haven't listed any cars yet.",
    "account.empty.saved": "No saved cars yet. Tap the heart on any listing to save it.",
    "account.empty.enquiries": "No enquiries received yet.",
    "account.list_first": "List your first car",
    "account.become_dealer": "Become a dealer",

    // Dealer Dashboard
    "dealer.title": "Dealer Dashboard",
    "dealer.subtitle": "Manage your inventory and enquiries",
    "dealer.add": "Add listing",
    "dealer.stats.total": "Total listings",
    "dealer.stats.approved": "Approved",
    "dealer.stats.pending": "Pending",
    "dealer.stats.views": "Total views",
    "dealer.my_listings": "My Listings",
    "dealer.recent_enquiries": "Recent Enquiries",
    "dealer.no_listings": "No listings yet.",
    "dealer.no_enquiries": "No enquiries yet.",
    "dealer.create_one": "Create one →",
    "dealer.register_title": "Register as a Dealer",
    "dealer.register_sub": "Get a verified profile and unlock dealer features",
    "dealer.field.name": "Dealer name",
    "dealer.field.phone": "Phone",
    "dealer.field.address": "Address",
    "dealer.field.description": "Description",
    "dealer.register_submit": "Register as dealer",
    "dealer.subscription": "Subscription",
    "dealer.upgrade": "Upgrade plan",
    "dealer.plan.basic": "Basic",
    "dealer.plan.pro": "Pro",
    "dealer.plan.premium": "Premium",

    // Admin
    "admin.title": "Admin Dashboard",
    "admin.subtitle": "Marketplace oversight and moderation",
    "admin.tab.pending": "Pending Approval",
    "admin.tab.listings": "All Listings",
    "admin.tab.users": "Users",
    "admin.tab.dealers": "Dealers",
    "admin.empty.pending": "All clear. No pending listings.",
    "admin.approve": "Approve",
    "admin.reject": "Reject",
    "admin.feature": "Feature",
    "admin.featured": "Featured",
    "admin.verify": "Verify",
    "admin.unverify": "Unverify",

    // Pricing
    "pricing.title": "Dealer Plans",
    "pricing.subtitle": "Choose a plan to grow your dealership in Cambodia",
    "pricing.month": "/month",
    "pricing.choose": "Choose plan",
    "pricing.current": "Current plan",
    "pricing.featured_upsell": "Promote this listing",
    "pricing.featured_upsell_d": "Top of homepage for 30 days · $9.99",
    "pricing.featured_buy": "Promote for $9.99",
    "pricing.basic.f1": "Up to 10 listings",
    "pricing.basic.f2": "Standard support",
    "pricing.basic.f3": "Listing analytics",
    "pricing.pro.f1": "Up to 50 listings",
    "pricing.pro.f2": "5 featured listings/month",
    "pricing.pro.f3": "Priority support",
    "pricing.premium.f1": "Unlimited listings",
    "pricing.premium.f2": "20 featured listings/month",
    "pricing.premium.f3": "Homepage dealer spotlight",
    "pricing.premium.f4": "24/7 priority support",
    "pricing.payment_provider": "Payment via ABA PayWay",

    // Common
    "common.loading": "Loading…",
    "common.search": "Search",
    "common.lang_toggle": "ខ្មែរ / EN",
    "footer.tag": "Cambodia's mobile-first marketplace for buying, selling and renting cars. Built for buyers, dealers and adventurers.",
    "footer.market": "Marketplace",
    "footer.company": "Company",
    "footer.rights": "All rights reserved.",
  },

  km: {
    // Brand
    "brand.name": "ផ្សារយានយន្ត",
    "brand.tagline": "រថយន្តក្តីសុបិន្ត​របស់​អ្នក គឺជា​គោលដៅ​របស់​យើង",

    // Nav
    "nav.home": "ទំព័រដើម",
    "nav.buy": "ទិញ",
    "nav.rent": "ជួល",
    "nav.sell": "លក់",
    "nav.account": "គណនី",
    "nav.admin": "អ្នកគ្រប់គ្រង",
    "nav.dashboard": "ផ្ទាំងគ្រប់គ្រង",
    "nav.sign_in": "ចូល",
    "nav.sign_out": "ចាកចេញ",
    "nav.pricing": "តម្លៃ",
    "nav.blog": "ប្លុក",

    // Home hero
    "home.hero.badge": "ផ្សារយានយន្តលំដាប់ទូរស័ព្ទនៅកម្ពុជា",
    "home.hero.title_1": "ស្វែងរករថយន្តរបស់អ្នក",
    "home.hero.title_2": "នៅទីនេះ។",
    "home.hero.subtitle": "ទិញ ជួល ឬលក់ — រហ័ស។ ឈ្មួញកណ្តាលបានផ្ទៀងផ្ទាត់ តម្លៃច្បាស់លាស់ និងបទពិសោធន៍ដូចកម្មវិធីទូរស័ព្ទ",
    "home.hero.search_placeholder": "ស្វែងរកតាមម៉ាក ម៉ូដែល ឬទីតាំង…",
    "home.hero.search_btn": "ស្វែងរក",
    "home.hero.tab.buy": "ទិញ",
    "home.hero.tab.rent": "ជួល",
    "home.hero.tab.sell": "លក់",

    // Home quick actions
    "home.qa.buy": "ទិញរថយន្ត",
    "home.qa.rent": "ជួលរថយន្ត",
    "home.qa.sell": "លក់រថយន្តរបស់ខ្ញុំ",
    "home.qa.dealer": "ឈ្មួញចូលប្រើ",

    // Home sections
    "home.featured": "រថយន្តពិសេស",
    "home.featured.sub": "ការផ្សាយលំដាប់ខ្ពស់ដែលបានជ្រើសរើស",
    "home.brands": "ម៉ាកដ៏ពេញនិយម",
    "home.latest": "ការផ្សាយចុងក្រោយ",
    "home.latest.sub": "ថ្មីៗនៅលើទីផ្សារ",
    "home.rentals": "រថយន្តជួលក្បែរអ្នក",
    "home.rentals.sub": "ចាប់ពី $៦៥/ថ្ងៃ · មានធានារ៉ាប់រង",
    "home.dealers": "ឈ្មួញដែលគួរឱ្យទុកចិត្ត",
    "home.dealers.sub": "ដៃគូដែលផ្ទៀងផ្ទាត់ទូទាំងកម្ពុជា",
    "home.how": "របៀបដំណើរការ",
    "home.how.browse.t": "រុករក",
    "home.how.browse.d": "ស្វែងរករថយន្តរាប់ពាន់គ្រឿងសម្រាប់លក់ ឬជួលនៅទូទាំងកម្ពុជា",
    "home.how.connect.t": "ភ្ជាប់",
    "home.how.connect.d": "ហៅទូរស័ព្ទ ឬ Telegram អ្នកលក់ភ្លាមៗ",
    "home.how.confidence.t": "ទំនុកចិត្ត",
    "home.how.confidence.d": "ឈ្មួញដែលផ្ទៀងផ្ទាត់ ស្ប៉េកច្បាស់លាស់ និងការផ្សាយដែលអនុម័ត",
    "home.view_all": "មើលទាំងអស់",

    // Buy/Rent
    "buy.title": "រថយន្តសម្រាប់លក់",
    "buy.results": "លទ្ធផល",
    "buy.empty": "គ្មានការផ្សាយត្រូវនឹងតម្រងរបស់អ្នកទេ",
    "buy.search.placeholder": "ស្វែងរក Toyota, Lexus, Honda…",
    "buy.filters": "តម្រង",
    "buy.clear": "សម្អាតតម្រង",
    "buy.sort.newest": "ថ្មីបំផុត",
    "buy.sort.price_asc": "តម្លៃ៖ ទាប → ខ្ពស់",
    "buy.sort.price_desc": "តម្លៃ៖ ខ្ពស់ → ទាប",
    "buy.sort.most_viewed": "មើលច្រើនជាងគេ",
    "rent.title": "រថយន្តជួល",
    "rent.subtitle": "ជម្រើសប្រចាំថ្ងៃ ប្រចាំសប្តាហ៍ និងប្រចាំខែ។ មានធានារ៉ាប់រង",
    "rent.cars": "គ្រឿង",
    "rent.empty": "គ្មានរថយន្តជួលត្រូវនឹងតម្រងរបស់អ្នកទេ",
    "rent.search.placeholder": "ស្វែងរករថយន្តជួល…",

    // Filter labels
    "filter.brand": "ម៉ាក",
    "filter.body": "តួរថយន្ត",
    "filter.fuel": "ប្រេងឥន្ធនៈ",
    "filter.transmission": "ប្រភេទប្រអប់លេខ",
    "filter.condition": "ស្ថានភាព",
    "filter.location": "ទីតាំង",
    "filter.price_min": "តម្លៃអប្បបរមា $",
    "filter.price_max": "តម្លៃអតិបរមា $",
    "filter.year_min": "ឆ្នាំចាប់ពី",
    "filter.year_max": "ដល់ឆ្នាំ",
    "filter.any": "ទាំងអស់",

    // Sell
    "sell.title": "លក់ ឬជួលរថយន្តរបស់អ្នក",
    "sell.subtitle": "ដាក់ផ្សាយត្រឹមតែប៉ុន្មាននាទី។ អ្នកគ្រប់គ្រងអនុម័តមុនពេលផ្សាយ",
    "sell.step.type": "ប្រភេទ",
    "sell.step.vehicle": "យានយន្ត",
    "sell.step.details": "ព័ត៌មានលម្អិត",
    "sell.step.photos": "រូបភាព",
    "sell.step.review": "ពិនិត្យ",
    "sell.type.q": "តើអ្នកកំពុងផ្សាយអ្វី?",
    "sell.type.sale": "សម្រាប់លក់",
    "sell.type.sale_d": "ផ្សាយរថយន្តរបស់អ្នកសម្រាប់លក់",
    "sell.type.rental": "សម្រាប់ជួល",
    "sell.type.rental_d": "ជួលរថយន្តរបស់អ្នកចេញ",
    "sell.photos.title": "បន្ថែមរូបភាព",
    "sell.photos.subtitle": "រូបភាពគុណភាពខ្ពស់ដល់ ១០ ជួយឱ្យការផ្សាយរបស់អ្នកលេចធ្លោ",
    "sell.photos.add": "បន្ថែមរូបភាព",
    "sell.photos.uploading": "កំពុងបង្ហោះ…",
    "sell.review.title": "ពិនិត្យការផ្សាយរបស់អ្នក",
    "sell.review.disclaimer": "ដោយការដាក់ស្នើ អ្នកយល់ព្រមថាការផ្សាយនឹងត្រូវបានពិនិត្យដោយ​ ស.ភ ផ្សារយានយន្ត មុនពេលបោះពុម្ព",
    "sell.back": "ត្រឡប់",
    "sell.next": "បន្ទាប់",
    "sell.submit": "ដាក់ស្នើ",
    "sell.success": "បានដាក់ស្នើការផ្សាយ! កំពុងរង់ចាំការអនុម័ត",

    // Listing detail
    "listing.specs": "លក្ខណៈបច្ចេកទេស",
    "listing.description": "ការពិពណ៌នា",
    "listing.similar": "រថយន្តស្រដៀងគ្នា",
    "listing.report": "រាយការណ៍ការផ្សាយនេះ",
    "listing.call": "ហៅអ្នកលក់",
    "listing.whatsapp": "WhatsApp",
    "listing.telegram": "Telegram",
    "listing.enquire": "ផ្ញើសំណួរ",
    "listing.req_rental": "ស្នើសុំជួល",
    "listing.private_seller": "អ្នកលក់ឯកជន",
    "listing.views": "ការមើល",
    "listing.featured": "ពិសេស",
    "listing.for_rent": "ជួល",
    "listing.from_per_mo": "ចាប់ពី",

    // Enquiry/Rental modals
    "enq.title": "ផ្ញើសំណួរ",
    "enq.name": "ឈ្មោះរបស់អ្នក",
    "enq.phone": "លេខទូរស័ព្ទ",
    "enq.email": "អ៊ីមែល (ស្រេចចិត្ត)",
    "enq.message": "សារ",
    "enq.submit": "ផ្ញើសំណួរ",
    "enq.success": "បានផ្ញើសំណួរ! អ្នកលក់នឹងទាក់ទងទៅអ្នក",
    "rent.modal.title": "ស្នើសុំជួល",
    "rent.modal.pickup": "ថ្ងៃយក",
    "rent.modal.return": "ថ្ងៃប្រគល់",
    "rent.modal.pickup_loc": "ទីតាំងយក",
    "rent.modal.notes": "កំណត់ចំណាំ",
    "rent.modal.submit": "ដាក់ស្នើសុំជួល",
    "rent.modal.success": "បានផ្ញើការស្នើសុំជួល!",

    // Auth
    "auth.welcome_back": "សូមស្វាគមន៍ត្រឡប់",
    "auth.signin_sub": "ចូលក្នុងគណនី ស.ភ ផ្សារយានយន្ត",
    "auth.email": "អ៊ីមែល",
    "auth.password": "ពាក្យសម្ងាត់",
    "auth.signin": "ចូល",
    "auth.no_account": "អ្នកថ្មី?",
    "auth.create_account": "បង្កើតគណនី",
    "auth.signup_title": "បង្កើតគណនីរបស់អ្នក",
    "auth.signup_sub": "ចាប់ផ្តើមទិញ ជួល ឬលក់រថយន្ត",
    "auth.role_buyer": "ខ្ញុំជាអ្នកទិញ",
    "auth.role_dealer": "ខ្ញុំជាឈ្មួញ",
    "auth.full_name": "ឈ្មោះពេញ",
    "auth.phone_optional": "លេខទូរស័ព្ទ (ស្រេចចិត្ត)",
    "auth.signup": "បង្កើតគណនី",
    "auth.have_account": "មានគណនីរួចហើយ?",
    "auth.welcome_toast": "សូមស្វាគមន៍ត្រឡប់!",
    "auth.created_toast": "បានបង្កើតគណនី!",

    // Account
    "account.tab.listings": "ការផ្សាយរបស់ខ្ញុំ",
    "account.tab.saved": "បានរក្សាទុក",
    "account.tab.enquiries": "សំណួរ",
    "account.tab.profile": "ប្រូហ្វាល",
    "account.empty.listings": "អ្នកមិនទាន់ផ្សាយរថយន្តណាមួយឡើយ",
    "account.empty.saved": "មិនទាន់រក្សាទុករថយន្ត។ ចុចលើបេះដូងដើម្បីរក្សាទុក",
    "account.empty.enquiries": "មិនទាន់ទទួលបានសំណួរ",
    "account.list_first": "ផ្សាយរថយន្តដំបូង",
    "account.become_dealer": "ក្លាយជាឈ្មួញ",

    // Dealer Dashboard
    "dealer.title": "ផ្ទាំងគ្រប់គ្រងឈ្មួញ",
    "dealer.subtitle": "គ្រប់គ្រងបញ្ជី និងសំណួរ",
    "dealer.add": "បន្ថែមការផ្សាយ",
    "dealer.stats.total": "ការផ្សាយសរុប",
    "dealer.stats.approved": "បានអនុម័ត",
    "dealer.stats.pending": "កំពុងរង់ចាំ",
    "dealer.stats.views": "ការមើលសរុប",
    "dealer.my_listings": "ការផ្សាយរបស់ខ្ញុំ",
    "dealer.recent_enquiries": "សំណួរថ្មីៗ",
    "dealer.no_listings": "មិនទាន់មានការផ្សាយ",
    "dealer.no_enquiries": "មិនទាន់មានសំណួរ",
    "dealer.create_one": "បង្កើតមួយ →",
    "dealer.register_title": "ចុះឈ្មោះជាឈ្មួញ",
    "dealer.register_sub": "ទទួលបានប្រូហ្វាលដែលផ្ទៀងផ្ទាត់ និងមុខងារពិសេស",
    "dealer.field.name": "ឈ្មោះឈ្មួញ",
    "dealer.field.phone": "លេខទូរស័ព្ទ",
    "dealer.field.address": "អាសយដ្ឋាន",
    "dealer.field.description": "ការពិពណ៌នា",
    "dealer.register_submit": "ចុះឈ្មោះជាឈ្មួញ",
    "dealer.subscription": "ការជាវ",
    "dealer.upgrade": "ដំឡើងគម្រោង",
    "dealer.plan.basic": "មូលដ្ឋាន",
    "dealer.plan.pro": "មាស",
    "dealer.plan.premium": "ពិសេស",

    // Admin
    "admin.title": "ផ្ទាំងគ្រប់គ្រង",
    "admin.subtitle": "ការត្រួតពិនិត្យ និងគ្រប់គ្រងផ្សារ",
    "admin.tab.pending": "រង់ចាំអនុម័ត",
    "admin.tab.listings": "ការផ្សាយទាំងអស់",
    "admin.tab.users": "អ្នកប្រើ",
    "admin.tab.dealers": "ឈ្មួញ",
    "admin.empty.pending": "ល្អហើយ! គ្មានការផ្សាយរង់ចាំអនុម័ត",
    "admin.approve": "អនុម័ត",
    "admin.reject": "បដិសេធ",
    "admin.feature": "ដាក់ពិសេស",
    "admin.featured": "ពិសេស",
    "admin.verify": "ផ្ទៀងផ្ទាត់",
    "admin.unverify": "មិនផ្ទៀងផ្ទាត់",

    // Pricing
    "pricing.title": "គម្រោងសម្រាប់ឈ្មួញ",
    "pricing.subtitle": "ជ្រើសរើសគម្រោងដើម្បីពង្រីកអាជីវកម្មរបស់អ្នក",
    "pricing.month": "/ខែ",
    "pricing.choose": "ជ្រើសរើស",
    "pricing.current": "គម្រោងបច្ចុប្បន្ន",
    "pricing.featured_upsell": "លើកស្ទួយការផ្សាយ",
    "pricing.featured_upsell_d": "នៅកំពូលទំព័រដើមរយៈពេល ៣០ថ្ងៃ · $9.99",
    "pricing.featured_buy": "លើកស្ទួយ​សម្រាប់ $9.99",
    "pricing.basic.f1": "រហូតដល់ ១០ ការផ្សាយ",
    "pricing.basic.f2": "ការជួយគាំទ្រធម្មតា",
    "pricing.basic.f3": "ការវិភាគការផ្សាយ",
    "pricing.pro.f1": "រហូតដល់ ៥០ ការផ្សាយ",
    "pricing.pro.f2": "ការផ្សាយពិសេស ៥/ខែ",
    "pricing.pro.f3": "ការគាំទ្រអាទិភាព",
    "pricing.premium.f1": "ការផ្សាយគ្មានដែនកំណត់",
    "pricing.premium.f2": "ការផ្សាយពិសេស ២០/ខែ",
    "pricing.premium.f3": "ការបង្ហាញឈ្មួញនៅទំព័រដើម",
    "pricing.premium.f4": "ការគាំទ្រអាទិភាព ២៤/៧",
    "pricing.payment_provider": "ទូទាត់តាមរយៈ ABA PayWay",

    // Common
    "common.loading": "កំពុងផ្ទុក…",
    "common.search": "ស្វែងរក",
    "common.lang_toggle": "EN / ខ្មែរ",
    "footer.tag": "ផ្សារយានយន្តលំដាប់ទូរស័ព្ទនៅកម្ពុជា សម្រាប់ការទិញ លក់ និងជួលរថយន្ត",
    "footer.market": "ផ្សារ",
    "footer.company": "ក្រុមហ៊ុន",
    "footer.rights": "រក្សាសិទ្ធិគ្រប់យ៉ាង",
  },
};
